module.exports = __webpack_public_path__ + "static/media/HS5089HJ.0a2ef36d.jpg";